/** Inclusive day count from batch start/end (calendar dates). */
export function batchDurationDays(startDate, endDate) {
  if (!startDate || !endDate) return null;
  const days = Math.max(1, (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24) + 1);
  return Number.isFinite(days) ? days : null;
}

/** "1 Day" vs "4 Days" */
export function formatDurationDaysLabel(days) {
  const n = Number(days);
  if (!Number.isFinite(n) || n <= 0) return '';
  const rounded = Math.round(n);
  return `${rounded} Day${rounded === 1 ? '' : 's'}`;
}

export function durationLabelFromBatch(startDate, endDate) {
  const days = batchDurationDays(startDate, endDate);
  return days != null ? formatDurationDaysLabel(days) : '';
}

/** Duration from packages (max day span). */
export function durationLabelFromPackages(packages) {
  if (!packages?.length) return '';
  const daySpans = packages
    .filter((p) => p.startDay != null && p.endDay != null)
    .map((p) => Math.max(1, Number(p.endDay) - Number(p.startDay) + 1));
  const days = daySpans.length ? Math.max(...daySpans) : 0;
  return days ? formatDurationDaysLabel(days) : '';
}
